module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-comorizeList-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "用户 / 账号 / 名称 / 企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "状态",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.status),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "status", $$v)
            },
            expression: "souchs.status"
          }
        }, _vm._l((_vm.types2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productname",
            "label": "名称",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "companyname",
            "label": "企业",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userdeptname",
            "label": "部门",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userdeptname || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "用户",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.name || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.phone || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.typename == '试用' ? 'success' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.typename) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usingstatus",
            "label": "状态",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: ['2', '3'].includes(scope.row.usingstatus) ? '' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.usingstatusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "effectivetime",
            "label": "生效时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "duetime",
            "label": "到期时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "相关订单",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-Business",
                on: {
                  "click": function($event) {
                    return _vm.handleAbout(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.usingstatus != 2) ? [(!scope.row.usingstatus2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondisabled",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconaccomplish",
                on: {
                  "click": function($event) {
                    return _vm.handleOpen(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e()], 2)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit model-xf-box",
          attrs: {
            "width": "800px",
            "title": "续费",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单账户:"
          }
        }, [_vm._v(_vm._s(_vm.orderUser) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.editlistLoading),
            expression: "editlistLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList2,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod2,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber2 - 1) * _vm.pageSize2 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "100px",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "名称",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productid",
            "label": "订单ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "单价(元)",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchaseMonth",
            "label": "续费时长(月)",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [_c('el-input', {
                attrs: {
                  "type": "number",
                  "min": "1"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcousMonth(1, row)
                  }
                },
                model: {
                  value: (row.purchaseMonth),
                  callback: function($$v) {
                    _vm.$set(row, "purchaseMonth", $$v)
                  },
                  expression: "row.purchaseMonth"
                }
              })]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative",
            "padding-bottom": "0px",
            "margin-top": "0px",
            "height": "80px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-checkbox', {
          staticClass: "el-checkbox1",
          on: {
            "change": _vm.checkboxOnclick
          },
          model: {
            value: (_vm.checked),
            callback: function($$v) {
              _vm.checked = $$v
            },
            expression: "checked"
          }
        }, [_vm._v(" 试用订单")]), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_allPrice",
          attrs: {
            "label": "总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "120px",
            "z-index": "9999"
          },
          attrs: {
            "disabled": _vm.disCheckBox
          },
          on: {
            "blur": function($event) {
              return _vm.priceloseF()
            }
          },
          model: {
            value: (_vm.allPrice),
            callback: function($$v) {
              _vm.allPrice = $$v
            },
            expression: "allPrice"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_ygPrice",
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.ygPrice) + " 元\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.adminVisible) ? _c('Detail', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "authProductId": _vm.detailOrderId
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "danger",
            "size": "medium",
            "disabled": _vm.sels1.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleDel()
            }
          }
        }, [_vm._v("\n          禁用\n        ")]), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "primary",
            "size": "medium",
            "disabled": _vm.sels3.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen()
            }
          }
        }, [_vm._v("\n          启用\n        ")])], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccefbb1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/authorizeList/ComorizeList.vue
// module id = 1770
// module chunks = 9